(function ($) {
  $(document).ready(function () {


    $(document).on("click", ".navbar-toggler", function () {
      // $(this).toggleClass('open');
      // $(this).parent().find('.navbar-collapse').toggleClass('show')
      // $('body').toggleClass('open');

      // Target po body klasi.
      $("body").toggleClass("menu-open");
    });

    /* Sticky header */
    var stickyHeader = $("#stickyheader").offset();
    if (stickyHeader && stickyHeader.length > 0) {
      var stickyHeaderTop = $("#stickyheader").offset().top;
      $(window).scroll(function () {
        if ($(window).scrollTop() > stickyHeaderTop) {
          $("#stickyheader").addClass("sticky-header");
        } else {
          $("#stickyheader").removeClass("sticky-header");
        }
      });
    }

    /**
     * Ajax category handler
     */
    $(document).on("click", ".category-target", function (e) {
      e.preventDefault();

      var catID = $(this).data("cat-id");
      var loaderTarget = $(".posts-list .loader");
      $(".accounts-target").addClass("loading");
      loaderTarget.removeClass("hidden");

      $.ajax({
        url: accountsAjax.ajaxurl,
        method: "POST",
        data: {
          action: "get_accounts",
          catID: catID,
          nonce: accountsAjax.nonce
        },
        dataType: "json",
        success: function (response) {
          if (response.success) {
            var content = response.data.content;
            $(".accounts-target").html(content);
          }
          loaderTarget.addClass("hidden");
          $(".accounts-target").removeClass("loading");
        },
        error: function (xhr, status, error) {
          loaderTarget.addClass("hidden");
          $(".accounts-target").removeClass("loading");
        }
      });
    });

    // Toggle Categories on mobile
    $(document).on("click", ".toggle-cats", function (e) {
      e.preventDefault();
      let self = $(this);
      self.parent().find("ul").toggleClass("toggled");
    });

    // Mounts toogle CPT mounts

    $(document).on(
      "click",
      "#info-reverse-block_607c8d671efdd .toggle-mounts",
      function (e) {
        e.preventDefault();

        $("#raid-block-block_607c90c50b3f5 .raid-target").toggleClass("shown");
      }
    );

    /** GET POST ID ON SINGLE PRODUCT PAGE */
    $(document).on("click", ".order-this-product", function (e) {
      e.preventDefault();

      var product_id = $(".middle-section h3").text();

      // console.log("Selected product ID: ", product_id);
    });

    /* Footer Tabs */
    // Wait for Bootstrap to be fully loaded
    window.addEventListener('load', function() {
      // Get all tab triggers
      const tabTriggers = document.querySelectorAll('#nav-tab button');
      
      // Activate first tab
      if (tabTriggers.length > 0) {
        tabTriggers[0].classList.add('active');
        document.querySelector(tabTriggers[0].dataset.bsTarget).classList.add('show', 'active');
      }
    });

    // Search button - hide menu on click

    $(document).on("click", ".search-btn-close", function () {
      $("body").removeClass("menu-open");
    });

    // Modal fix
    $(document).on("click", ".button-fix", function () {
      $(".modal-fix").addClass("d-block opacity-1 mt-md-0 mt-5");
      $(".modal-dialog-fix").addClass("mt-5");
      // console.log("portal");
    });
    // Close modal
    $(document).on("click", ".form-btn-close", function () {
      $(".modal-fix").removeClass("d-block opacity-1 show").addClass('d-none');
      $(".modal-backdrop").addClass("d-none");
      $("body").removeClass("modal-open");
    });



    // Dynamic element removal
    const removeDynamicElements = () => {
      // Check for elements with specific style combinations
      const elements = document.querySelectorAll('div');
      elements.forEach(div => {
        // Check for inline styles
        if (div.style.display === 'block' && div.style.clear === 'both') {
          div.remove();
        }

        // Check for shadow DOM elements
        if (div.shadowRoot) {
          const shadowImg = div.shadowRoot.querySelector("img[alt='Optimized by NitroPack.io']");
          if (shadowImg) {
            div.remove();
          }
        }

        // Check computed styles
        const computedStyle = window.getComputedStyle(div);
        if (computedStyle.display === 'block' && computedStyle.clear === 'both') {
          div.remove();
        }
      });
    };

    // Initial removal
    removeDynamicElements();

    // Set up observer for dynamically added elements
    const observer = new MutationObserver((mutations) => {
      removeDynamicElements();
    });

    // Start observing the document with configured parameters
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    // Periodic check (every 2 seconds for the first minute)
    let checkCount = 0;
    const interval = setInterval(() => {
      removeDynamicElements();
      checkCount++;
      if (checkCount >= 30) {
        clearInterval(interval);
      }
    }, 2000);

    // Single AJAX handler for both button types
    $('.category-target, .category-button').on('click', function (e) {
      e.preventDefault();

      var $this = $(this);
      var catID = $this.data('cat-id') || $this.data('category');
      var $container = $('.accounts-target');

      if (!catID) {
        return;
      }

      $this.addClass('loading');
      $container.addClass('loading');

      $.ajax({
        url: accountsAjax.ajaxurl,
        type: 'POST',
        data: {
          action: 'get_accounts',
          nonce: accountsAjax.nonce,
          catID: catID
        },
        dataType: 'json',
        success: function (response) {
          if (response.success && response.data.content) {
            $container.html(response.data.content);
          }
        },
        error: function () {
          // Silent fail - remove error logging
        },
        complete: function () {
          $this.removeClass('loading');
          $container.removeClass('loading');
        }
      });
    });

    // Initialize mobile badge slider
    function initMobileBadgeSlider() {
      const $slider = $('.badges-mobile-slider');

      if (window.innerWidth < 768) {
        if (!$slider.hasClass('slick-initialized')) {
          $slider.slick({
            dots: true,
            arrows: false,
            infinite: true,
            speed: 300,
            autoplaySpeed: 2000,
            slidesToShow: 2,
            slidesToScroll: 1,
            // centerMode: true,
            autoplay: true,
            responsive: [{
              breakpoint: 560,
              settings: {
                slidesToShow: 1,
                // centerMode: true,
                centerPadding: '40px'
              }
            }]
          });
        }
      } else if ($slider.hasClass('slick-initialized')) {
        $slider.slick('unslick');
      }
    }

    initMobileBadgeSlider();
    let resizeTimer;
    $(window).on('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(initMobileBadgeSlider, 250);
    });
  });
})(jQuery);
